import * as yup from 'yup';

export const ExchangeKeyMemoValidationSchema = yup
  .string()
  .max(40, 'Max 40 characters')
  .nullable();
